
export default (urlParameters) => {
  return {
    ads_allowed: false,
  }
}